import React from "react";
import { useTranslation } from "react-i18next";
import CustomInputSearch from "components/common/CustomInputSearch";
import CustomPaginatedSelect from "components/common/CustomPaginatedSelect";
import { sortOptions } from "constant/SelectOptions";
import { roleOptionsFilter } from "constant/SelectOptions";
import { filterOptions } from "constant/SelectOptions";

export default function TableFilter({
  search,
  setSearch,
  sort,
  setSort,
  role,
  setRole,
  categories,
  setCategories,
  subCategory,
  setSubCategory,
  loadCategoryOptions,
  loadSubCategoryOptions,
  filter,
  setFilter,
  showSearch = false,
  showSort = false,
  showFilter = false,
  showCategory = false,
  showSubCategory = false,
  filterOptionsList,
  total,
  totalLabel,
  showRole = false,
  subCategoryDisabled = false,
}) {
  const { t } = useTranslation("tables");
  return (
    <>
      <div className="row tableAction">
        {showSearch && (
          <div className="col-md-3">
            <CustomInputSearch
              id="search"
              name="search"
              label={t("filter.search")}
              placeholder={t("filter.search")}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
          </div>
        )}
        {showSort && (
          <div className="col-md-3">
            <CustomPaginatedSelect
              id="sort"
              name="sort"
              label={t("filter.sort")}
              placeholder={t("filter.all")}
              isSearchable={false}
              onChange={(selectedOption) => {
                setSort(selectedOption || []);
              }}
              staticOptions={sortOptions || []}
              value={sort}
            />
          </div>
        )}
        {showFilter && (
          <div className="col-md-3">
            <CustomPaginatedSelect
              id="filter"
              name="filter"
              label={t("filter.filter")}
              placeholder={t("filter.all")}
              isSearchable={false}
              onChange={(selectedOption) => {
                setFilter(selectedOption || []);
              }}
              staticOptions={filterOptionsList || filterOptions || []}
              value={filter}
            />
          </div>
        )}
        {showRole && (
          <div className="col-md-3">
            <CustomPaginatedSelect
              id="role"
              name="role"
              label={t("filter.byRole")}
              placeholder={t("filter.all")}
              isSearchable={false}
              onChange={(selectedOption) => {
                setRole(selectedOption || []);
              }}
              staticOptions={roleOptionsFilter || []}
              value={role}
            />
          </div>
        )}
        {showCategory && (
          <div className="col-md-3">
            <CustomPaginatedSelect
              label={t("filter.byCategory")}
              name="categories"
              placeholder={t("filter.selectCategory")}
              value={categories}
              onChange={setCategories}
              loadOptions={loadCategoryOptions}
            />
          </div>
        )}
        {showSubCategory && (
          <div className="col-md-3">
            <CustomPaginatedSelect
              // key={categories?.value}
              label={t("filter.bySubCategory")}
              name="subCategories"
              placeholder={t("filter.selectSubCategory")}
              value={subCategory}
              onChange={setSubCategory}
              loadOptions={loadSubCategoryOptions}
              disabled={subCategoryDisabled}
            />
          </div>
        )}
        {total !== undefined && total !== null && (
          <div className="col-md-3 ml-auto text-right align-self-end mb-3">
            <strong>
              {totalLabel ?? t("filter.total")}: {total}
            </strong>
          </div>
        )}
      </div>
    </>
  );
}
